import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/costcenter",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "costcentre-page",
        component: () => import("@/views/CostCentre/CostCentrePage.vue"),
        meta: {
          title: "Cost Center",
          titleLocalizationCode: "Cost_Center",
          desc: "Cost center page",
          descLocalizationCode: "Cost_Center_Page",
          sidebarElement: false,
          permissionCodes: [
            "CostCenter.Read",
            "CostCenter.Add",
            "CostCenter.Edit",
            "CostCenter.Delete",
          ],
        },
      },
    ],
  },
];
